$(document).ready(function(){

  if(document.querySelector('.calander_vm') != null){
  
  var display = document.querySelector("#display");
  var days = document.querySelector("#days");
  var previous = document.querySelector(".arrow.left");
  var next = document.querySelector(".arrow.right");
  
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth();
  
  var markedDays = JSON.parse($('#marked_dates').html()).marked_date || [];
   markedDays = markedDays.filter((x) => {return x != ''}); 
    console.log(markedDays.length);
  
  function calendar() {
    $('.after_60_day').hide();  
    var dilevery_date_string = document.querySelector('.calander_vm').getAttribute("data-dilevery_date");
    var dilevery_date = new Date(dilevery_date_string);
    var after_60  = new Date(document.querySelector('.calander_vm').getAttribute("data-after_60_day"));

    var current_datstring = date.toDateString();
    
    if(after_60 < date){
      
      console.log("ssssssssss");
      
      $('#frame').hide();
      if(markedDays.length == 60){
        $('.after_60_day_success').show();
      } else{
        $('.after_60_day_error').show();
      }
      return;
    }
    if(document.querySelector('.calander_vm').getAttribute("data-date_check") == "false"){
      $('#frame').hide();
      if(after_60 > current_datstring){
        if(markedDays.length == 60){
          $('.after_60_day_success').show();
          return;
        } else{
          $('.after_60_day_error').show();
          return;
        }
      }
      return;
    }
    
    days.innerHTML = '';
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    var firstDayIndex = firstDay.getDay();
    var numberOfDays = lastDay.getDate();
    var nextDays = new Date(year, month, numberOfDays).getDay();
    display.textContent = new Date(year, month).toLocaleString("en-US", {
      month: "long",
      year: "numeric"
    });
  
    for (var i = 0; i < firstDayIndex; i++) {
      const div = document.createElement("div");
      days.appendChild(div);
    }
  
    for (var j = 1; j <= numberOfDays; j++) {
      var div = document.createElement("div");
      var currDate = new Date(year, month, j);
      var dateString = currDate.toDateString();
      div.dataset.date = dateString;
      div.textContent = j;
  
       if (currDate.getFullYear() === new Date().getFullYear() && currDate.getMonth() === new Date().getMonth() && currDate.getDate() === new Date().getDate() && dilevery_date <= currDate && document.querySelector('.calander_vm').dataset.dilevery_date != '') {
          div.classList.add("current-date");
        } else {
          div.classList.add("inactive");
        }
      // Check if the day is already marked
      if (markedDays.includes(div.dataset.date)) {
        div.classList.add("marked");
      }
  
      days.appendChild(div);
    }
  
    // Inactive days after the end of the month
    for (var i = nextDays + 1; i < 7; i++) {
      const div = document.createElement("div");
      days.appendChild(div);
    }
  }

    $('body').on("click",".current-date",function(e){
         var dateString = $(this).attr("data-date");
      
        console.log(markedDays.includes(dateString));
      
      if (!markedDays.includes(dateString)) {
        
        markedDays.push(dateString);
        $(this).addClass('marked');

        console.log(markedDays);      
          if(markedDays.length == 60){
            $('.after_60_day_success').show();
            $('#frame').hide();
          } 

        
        var data_form =  new FormData();
        data_form.append("Customer ID",$('.calander_vm').attr("data-customer_id"));
        data_form.append("Marked Dates",markedDays.toString()+',');
        
       $.ajax({
        url: $('.calander_vm').attr('data-action_url'),
        type: 'POST',
        data: data_form,
        processData: false, 
        contentType: false, 
        success: function(data, status) {
            console.log("Success");
        },
        error: function(xhr, status, error) {
            $('.calander_vm').parent().append('<p class="message_after_call">Error updating...Contact Us!</p>');
        }
    });
        
      }
    });
  
  previous.addEventListener("click", () => {
    if (month === 0) {
      month = 11;
      year--;
    } else {
      month--;
    }
    calendar();
  });
  
  next.addEventListener("click", () => {
    if (month === 11) {
      month = 0;
      year++;
    } else {
      month++;
    }
    calendar();
  });
  
  calendar();

  }

});


